import { useMemo } from 'react';

import { t } from '../../../services/translation/translation';
import { formatDate, getDate, getMonth, getYear, parseDate } from '../../../utils/date';
import { Cell } from '../Cell';
import { Controls } from '../Controls';
import { FortnightValue } from '../types';

type Props = {
  selectedFornight?: FortnightValue;
  displayYear: number;
  displayMonth: number;
  onPreviousMonth: () => void;
  onNextMonth: () => void;
  onSelectFortnight: (_fortnight: FortnightValue) => void;
  onHeaderClick: () => void;
  maxDate?: number;
  minDate?: number;
};

export const FortnightView = ({
  displayMonth,
  displayYear,
  onNextMonth,
  onPreviousMonth,
  onSelectFortnight,
  selectedFornight,
  onHeaderClick,
  maxDate,
  minDate,
}: Props) => {
  const { maxYear, minYear, maxMonth, minMonth, maxFortnight, minFortnight } = useMemo(() => {
    const maxDay = maxDate ? getDate(maxDate) : undefined;
    const minDay = minDate ? getDate(minDate) : undefined;
    const maxFortnight = maxDay ? (maxDay < 16 ? 1 : 2) : undefined;
    const minFortnight = minDay ? (minDay < 16 ? 1 : 2) : undefined;
    const maxYear = maxDate ? getYear(maxDate) : undefined;
    const minYear = minDate ? getYear(minDate) : undefined;
    const maxMonth = maxDate ? getMonth(maxDate) : undefined;
    const minMonth = minDate ? getMonth(minDate) : undefined;

    return { maxYear, minYear, maxMonth, minMonth, maxFortnight, minFortnight };
  }, [maxDate, minDate]);

  const isCellDisabled = (fortnight: FortnightValue) =>
    (maxYear != null &&
      maxMonth != null &&
      maxFortnight != null &&
      (displayYear > maxYear ||
        (displayYear === maxYear && displayMonth > maxMonth) ||
        (displayYear === maxYear && displayMonth === maxMonth && fortnight > maxFortnight))) ||
    (minYear != null &&
      minMonth != null &&
      minFortnight != null &&
      (displayYear < minYear ||
        (displayYear === minYear && displayMonth < minMonth) ||
        (displayYear === minYear && displayMonth === minMonth && fortnight < minFortnight)));

  return (
    <div className="inline-block">
      <Controls
        onHeaderClick={onHeaderClick}
        onPrevious={onPreviousMonth}
        onNext={onNextMonth}
        label={formatDate(parseDate(`${displayYear}-${displayMonth + 1}-15`, 'YYYY-M-D'), t('date.month-year'))}
        isNextDisabled={
          maxYear != null &&
          maxMonth != null &&
          (displayYear > maxYear || (displayYear === maxYear && displayMonth >= maxMonth))
        }
        isPreviousDisabled={
          minYear != null &&
          minMonth != null &&
          (displayYear < minYear || (displayYear === minYear && displayMonth <= minMonth))
        }
      />

      <div>
        <div className="w-64 grid grid-cols-2 gap-1">
          <Cell onClick={() => onSelectFortnight(1)} isSelected={selectedFornight === 1} isDisabled={isCellDisabled(1)}>
            {t('common.first-fortnight')}
          </Cell>
          <Cell onClick={() => onSelectFortnight(2)} isSelected={selectedFornight === 2} isDisabled={isCellDisabled(2)}>
            {t('common.second-fortnight')}
          </Cell>
        </div>
      </div>
    </div>
  );
};
